// This function is only specific to behaviour on iOS devices

function iOSHideVideoButtons() {
    if (
        (/iPad|iPhone|iPod/.test(navigator.userAgent) ||
            (navigator.userAgent === 'MacIntel' &&
                navigator.maxTouchPoints > 1)) &&
        !window.MSStream
    ) {
        // hide iOS video controls that don't work due to apple restrictions
        document
            .querySelectorAll(
                '.btn.btn-primary.volume-down, .btn.btn-primary.volume-up, .btn.btn-primary.fullscreen'
            )
            .forEach((btn) => {
                btn.classList.add('d-none');
            });
    }
}

$(document).ready(function () {
    iOSHideVideoButtons();
});
